import { Injectable } from '@angular/core';
import { LogedInUserModel, PagerModel } from 'src/app/models';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable(
  {
    providedIn: 'root'
  }
)
/**
 * @description
 * GlobalVars are used all around the applicatin. They are storing data in run time and are recreated on application startup.
 * GlobalVars are destoroyed on browser close.
 */
export class GlobalVars {

  private refreshCmsMenu = new BehaviorSubject<boolean>(false);
  get getRefreshCmsMenu() {
    return this.refreshCmsMenu.asObservable();
  }
  set setRefreshCmsMenu(input: boolean) {
    this.refreshCmsMenu.next(input);
  }


  /**
    * @description
    * Getter Setter that stores in run time user role.
    * Value stored is boolean.
    * True for public
    * False for admin
   */
  private isPublicRole = true;
  get getIsPublicRole(): boolean {
    return this.isPublicRole;
  }
  set setIsPublicRole(input: boolean) {
    this.isPublicRole = input;
  }

  /**
   * @description
   * Getter Setter that stores in run time user login status.
   * Value stored is boolean.
   * True for loged in
   * False for loged out
  */
  private loginStatus = new BehaviorSubject<boolean>(false);
  get getLoginStatus() {
    return this.loginStatus.asObservable();
  }
  set setLoginStatus(input: boolean) {
    this.loginStatus.next(input);
  }

  // private isLogedIn = false;
  // get getIsLogedIn(): boolean {
  //   return this.isLogedIn;
  // }
  // set setIsLogedIn(input: boolean) {
  //   this.isLogedIn = input;
  // }

  /**
   * @description
   * Getter Setter that stores in run time user profile.
   * Value stored is type of LogedInUserModel
   */
  private userProfile = {} as LogedInUserModel;
  get getUserProfile(): LogedInUserModel {
    return this.userProfile;
  }
  set setUserProfile(input: LogedInUserModel) {
    this.userProfile = input;
  }

}

/**
 * @description
 * GlobalConsts are static variables that defines
 */
@Injectable()
export class GlobalConsts {
  /**
   * @description
   * Api Base url. Value is dependat of the type od enviroment, debbuging or production. */
  static apiBaseUrl = environment.apiUrl;

  /**
   * @description
   * Local Storage key for user log in status */
  static IsLogedInLsKey = 'isUserLogedIn';

  /**
   * @description
   * Local Storage key for user login profile */
  static UserProfileLsKey = 'UserProfileLsKey';

  /**
   * @description
   * File Upload Base url. Value is dependat of the type od enviroment, debbuging or production. */
  static FileUploadApiUrl = environment.apiUrl + 'FileManagement/UploadFile';

  /**
   * @description
   * Default paging config. */
  static PageingDefaults: PagerModel = { MaxResultCount: 2147483647, SkipCount: 0, Sorting: 'Name ASC' };

}
